import { render, staticRenderFns } from "./Desafios.vue?vue&type=template&id=ef2fe0d4&"
import script from "./Desafios.vue?vue&type=script&lang=js&"
export * from "./Desafios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports